<template>
  <div>
    <!--evaluacion inicial-->

    <div class="col-12 mb-0">
      <section-title content="Evaluación Inicial" :has-line="true" />
    </div>

    <div v-if="initEvaluation.length == 0" class="col-12 ">
      <div class="col-3 pt-0">
        <ValidationProvider v-slot="{ errors }" name="Fecha" rules="required">
          <custom-date-picker
            v-model="initEvaluationDate"
            label="Fecha: "
            format="dd/MMM./yyyy"
            required
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 mt-4 p-2">
        <ValidationProvider
          v-slot="{ errors }"
          name="comentario evaluacion"
          rules="required"
        >
          <custom-text-area
            id="initEvaluationCommentId"
            v-model="evaluationComment"
            class=""
            label="Comentario"
            :maxlength="500"
            placeholder="Escribir aqui"
            required
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
    </div>

    <div v-if="initEvaluation.length > 0">
      <div class="col-12">
        <div class="col-3 pt-0">
          <span>
            <b>
              Fecha:
              <br />
            </b>
          </span>
          <span>{{ initEvaluation[0].date }}</span>
        </div>
      </div>
      <div class="col-12">
        <div class="col-5">
          <span>
            <b>
              Comentario:
              <br />
              <b />
            </b>
          </span>
          <span>{{ initEvaluation[0].comment }}</span>
        </div>
      </div>
      <!--Documentos de respaldo-->
      <div class="col-12 mt-4">
        <section-title
          content="Documentos de Respaldo al Proceso de Determinación"
          :has-line="true"
        />
      </div>

      <!--TAB HEADER-->
      <div class="col-12">
        <div class=" header thead-property d-flex align-items-center p-3">
          <div class="col-4 pt-0">
            <span>Documento</span>
          </div>
          <div class="col-4 pt-0">
            <span>Archivo</span>
          </div>
          <div class="col-4 pt-0">
            <span />
          </div>
        </div>
      </div>

      <!--TAB SIN ITEM-->
      <div
        v-if="
          backupDocumentation.length == 0 &&
            !isCreatingBackupDocumentation &&
            !isEditingBackupDocumentation
        "
        class="col-12"
      >
        <div class="mb-4 p-4 empty-table">
          <div class="col-12 text-center">
            <button
              id="btnFA"
              class="btn bg-light-white w-75 pt-1"
              @click="
                isCreatingBackupDocumentation = !isCreatingBackupDocumentation
              "
            >
              <i class="fas fa-file-plus pr-4 text-green" />
              <span class="text-button-add-document">
                Presione aqu&iacute; para a&ntilde;adir documento de respaldo
              </span>
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="backupDocumentation.length > 0 && !isCreatingBackupDocumentation"
      >
        <div v-for="doc in backupDocumentation" :key="doc.id" class="col-12">
          <div class="  d-flex align-items-center p-3">
            <div class="col-4 pt-0">
              <span>{{ doc.documentName }}</span>
            </div>
            <div class="col-4 pt-0">
              <span>{{ doc.fileName }}</span>
            </div>
            <div class="col-4 pt-0">
              <div class="dropdown text-right">
                <button
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu pb-0 mt-1">
                  <a class="drop-item cursor-pointer">
                    <em class="fas fa-edit text-green pr-1" />
                    <span>Editar</span>
                  </a>
                  <a class="drop-item cursor-pointer">
                    <em class="fas fa-times-circle text-red pr-1" />
                    <span>Eliminar</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Creando documento de respaldo-->
      <div v-if="isCreatingBackupDocumentation" class="col-12">
        <div class="col-12">
          <validation-observer ref="backupDocumentationForm">
            <form novalidate @submit.prevent="backupDocumentationItem">
              <CustomCollapse id="serviceDocumentAdd" class="mt-0">
                <CustomCollapseItem
                  parent-id="serviceDocumentAdd"
                  title="Añadir Documento"
                  :selected="true"
                  expanded
                >
                  <div class="col-12 d-flex">
                    <div class="col-4">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="tipo de dni"
                        rules="required"
                      >
                        <custom-drop-down
                          v-model="selectedDocumentType"
                          fieldname="type"
                          fieldkey="id"
                          :options="documentTypes"
                          placeholder="Seleccione"
                          label="Tipo de Documento:"
                          :error="errors[0]"
                          :custom-error-msg.sync="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-4 ">
                      <div class="col-10 ">
                        <span><b>Fuente:</b></span>
                      </div>
                      <div v-if="!attachedDocument" class="col-10 text-center">
                        <button
                          id="btnFA"
                          class="btn bg-light-white w-100 pt-1"
                          @click="addDocument()"
                        >
                          <i class="fas fa-file-plus pr-4 text-green" />
                          <span class="text-button-add-document">
                            Presione aquí para anejar
                          </span>
                        </button>
                      </div>
                      <div v-if="attachedDocument" class="col-10 d-flex ">
                        <div class="col-5 pt-1 pl-0">
                          <span>{{ backupDocumentation[0].fileName }}</span>
                        </div>
                        <div class="col-5 pt-0  d-flex justify-content-end">
                          <div class="btn btn-border-green px-2 pt-0">
                            <i class="fas fa-file-download text-green pt-2" />
                          </div>
                          <div class="ml-1 btn btn-border-red px-2 pt-0">
                            <i class="fa fa-times-circle text-red pt-2" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 d-flex justify-content-end mt-3">
                      <ActionButton
                        variant="success m-2 px-4"
                        type="submit"
                        @click="
                          isCreatingBackupDocumentation = !isCreatingBackupDocumentation
                        "
                      >
                        Añadir
                      </ActionButton>
                    </div>
                  </div>
                </CustomCollapseItem>
              </CustomCollapse>
            </form>
          </validation-observer>
        </div>
      </div>

      <!--Informacion de evaluaciones-->
      <div class="col-12 mt-4">
        <section-title content="Información de evaluaciones" :has-line="true" />
      </div>
      <div class="col-12">
        <div class=" header thead-property d-flex align-items-center p-3">
          <div class="col-1 pt-0" />
          <div class="col-2 pt-0">
            <span>Servicio</span>
          </div>
          <div class="col-2 pt-0">
            <span>Disciplina</span>
          </div>
          <div class="col-2 pt-0">
            <span>Estatus</span>
          </div>
          <div class="col-2 pt-0 pl-4">
            <span>Aceptada</span>
          </div>
          <div class="col-2 pt-0 pl-4">
            <span>¿Esta evaluación será utilizada en una determinación de elegibilidad?</span>
          </div>
          <div class="col-1 pt-0">
            <span />
          </div>
        </div>
      </div>

      <div
        v-for="evaluationInfoItem in evaluationsInfo"
        :key="evaluationInfoItem.id"
        class="col-12"
      >
        <div class="col-12 ">
          <div class="border-bottom d-flex align-items-center p-3">
            <div class="col-1 pt-0">
              <div class="custom-control custom-checkbox">
                <input
                  :id="`chkTable-${evaluationInfoItem}`"
                  type="checkbox"
                  class="custom-control-input"
                />
                <label
                  class="custom-control-label font regular"
                  :for="`chkTable-${evaluationInfoItem}`"
                />
              </div>
            </div>
            <div class="col-2 pt-0">
              <span>{{ evaluationInfoItem.service }}</span>
            </div>
            <div class="col-2 pt-0">
              <span>{{ evaluationInfoItem.discipline }}</span>
            </div>
            <div class="col-2 pt-0">
              <span>{{ evaluationInfoItem.status }}</span>
            </div>
            <div class="col-2 pt-0">
              <custom-radio-button
                v-model="evaluationInfoItem.accepted"
                :name="`accepted-${evaluationInfoItem.id}`"
                :options="radioButtonsOptions"
                is-inline
              />
            </div>
            <div class="col-2 pt-0">
              <custom-radio-button
                v-model="determinesEvaluationInfo"
                :name="`determines-${evaluationInfoItem.id}`"
                :options="radioButtonsOptions"
                is-inline
              />
            </div>
            <div class="col-2 pt-0 ">
              <div class="dropdown">
                <button
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu pb-0 mt-1">
                  <a class="drop-item cursor-pointer">
                    <em class="fas fa-times-circle text-red pr-1" />
                    <span>Eliminar</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="evaluationInfoItem.accepted == false && !rejectionReason"
          class="col-12 "
        >
          <div class="col-4 px-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="no acepta por"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedReason"
                fieldname="name"
                fieldkey="id"
                :options="notAcceptedReasons"
                placeholder="Seleccione"
                label="No acepta por:"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-12 pt-4 pr-2 pl-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Comentario de elegibilidad"
              rules="required"
            >
              <custom-text-area
                v-model="rejectionComment"
                :maxlength="500"
                placeholder="Escribir aqui"
                required
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-12 d-flex justify-content-end mt-0 px-0 pr-1">
            <ActionButton
              variant="success m-2 px-4"
              type="submit"
              @click="saveRejectionReasons()"
            >
              Guardar
            </ActionButton>
          </div>
        </div>
        <div
          v-if="evaluationInfoItem.accepted == false && rejectionReason"
          class="col-12 mt-4 d-flex"
        >
          <div class="col-5">
            <div class="col-3 pt-0">
              <span>
                <b>
                  No acepta por:
                  <br />
                </b>
              </span>
              <span>{{ rejectionReason.reason.name }}</span>
            </div>
          </div>

          <div class="col-5">
            <div class="col-5 pt-0">
              <span>
                <b>
                  Comentario:
                  <br />
                  <b />
                </b>
              </span>
              <span>{{ rejectionReason.comment }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-row-reverse bd-highlight w-100 my-4">
        <div class="mx-0 bd-highlight ml-2">
          <ActionButton
            data-target="#add-previous-evaluations-modal"
            data-toggle="modal"
            data-backdrop="static"
            variant="success"
            i="fas fa-file-plus"
          >
            A&ntilde;adir
          </ActionButton>
        </div>
        <div class="mx-0 bd-highlight">
          <ActionButton variant="success" i="fas fa-file-edit">
            Modificar
          </ActionButton>
        </div>
      </div>

      <div class="col-12 mt-4">
        <section-title
          content="Determinación de Elegibilidad"
          :has-line="true"
        />
      </div>
      <div class="col-12">
        <controversy-banner
          title="Cuestionario de Intervención"
          pei-status="Completado"
        />
      </div>

      <div class="col-12 d-flex justify-content-betweem">
        <div class="col-4">
          <ValidationProvider v-slot="{ errors }" name="Fecha" rules="required">
            <custom-date-picker
              v-model="impedimentDate"
              label="Fecha: "
              format="dd/MMM./yyyy"
              required
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </ValidationProvider>
        </div>
        <div class="col-4">
          <custom-radio-button
            v-model="eligible"
            label="Elegible"
            name="eligible"
            :options="radioButtonsOptions"
            is-inline
          />
        </div>
        <div v-if="eligible" class="col-4">
          <ValidationProvider
            v-slot="{ errors }"
            name="impedimento"
            rules="required"
          >
            <custom-drop-down
              v-model="selectedImpedimentType"
              fieldname="name"
              fieldkey="id"
              :options="impedimentTypes"
              placeholder="Seleccione"
              label="Impedimento:"
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>

      <div
        v-if="selectedImpedimentType && selectedImpedimentType.id == 0"
        class="col-12 mt-4 p-4 impediment-background"
      >
        <div class="col-12 pl-1">
          <section-title content="Impedimentos Múltiples" reverse />
        </div>
        <div class="col-12 d-flex mb-4 ">
          <div class="col-4">
            <ValidationProvider
              v-slot="{ errors }"
              name="impedimentos"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedImpedimentTypeItems"
                fieldname="name"
                fieldkey="id"
                :options="impedimentTypes"
                placeholder="Seleccione"
                label="Impedimento:"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4  mt-3">
            <ActionButton variant="success m-2 px-4" type="submit">
              Añadir
            </ActionButton>
          </div>
        </div>
        <div class="col-12 mx-2 impediment-divider" />

        <div class="col-12 py-0 impediment-title">
          <span>Impedimentos Seleccionados</span>
        </div>
        <div class="col-12">
          <CustomChipsGroup
            :selected-items="impedimentSelectedItems"
            object-text="name"
            object-id="id"
            object-title="title"
            object-sub-title="subTitle"
            no-background
          />
        </div>
      </div>

      <div class="col-12 mt-4 px-4">
        <ValidationProvider
          v-slot="{ errors }"
          name="Comentario de elegibilidad"
          rules="required"
        >
          <custom-text-area
            v-model="eligibilityComment"
            label="Comentario"
            :maxlength="500"
            placeholder="Escribir aqui"
            required
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 d-flex justify-content-start">
        <div class="col-5 cuestion-text pt-4">
          <span>
            Cantidad de reuniones que se llevaron a cabo para determinar
            elegibilidad:
          </span>
        </div>
        <div class="col-2 px-4 text-left">
          <ValidationProvider
            v-slot="{ errors }"
            name="numero de reuniones"
            rules="required"
          >
            <custom-drop-down
              v-model="selectedMeetingsNumber"
              fieldname="number"
              fieldkey="id"
              :options="meetingsNumber"
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-start">
        <div class="col-4 cuestion-text pt-4">
          <span>
            ¿Fue necesaria la participación de un especialista de la salud?
          </span>
        </div>
        <div class="col-2 px-4 text-left">
          <custom-radio-button
            v-model="specialistNeeded"
            name="specialistNeeded"
            :options="radioButtonsOptions"
            is-inline
          />
        </div>
      </div>
      <div v-if="specialistNeeded" class="col-12 mt-2 ">
        <div class="col-12 d-flex justify-content-start">
          <div class="custom-control custom-checkbox">
            <input
              :id="`chkTable-${evaluationsInfoItems}`"
              type="checkbox"
              class="custom-control-input"
            />
            <label
              class="custom-control-label font regular"
              :for="`chkTable-${evaluationsInfoItems}`"
            />
          </div>
          <div class="col-11 certified-text">
            <span>
              Certificamos que en caso de que el niño o joven haya sido
              considerado elegible para servicios de educación especial,
              <b>
                la decisión no se ha basado primordialmente en alguno de los
                siguientes factores: falta de instrucción en lectura o
                matemáticas o dominio limitado del idioma español.
              </b>
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 mt-4">
        <section-title content="Firmas de Participantes" :has-line="true" />
      </div>

      <div class="col-12">
        <div class=" header thead-property d-flex align-items-center p-4">
          <div class="col-4 pt-0">
            <span>Nombre</span>
          </div>
          <div class="col-4 pt-0">
            <span>Puesto</span>
          </div>
          <div class="col-4 pt-0">
            <span />
          </div>
        </div>
      </div>

      <div class="col-12 ">
        <div class="border-bottom d-flex align-items-center p-4">
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Fecha"
              rules="required"
            >
              <custom-input
                v-model="signature"
                type="text"
                placeholder="Escribir Nombre"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="tipo de dni"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedPosition"
                fieldname="name"
                fieldkey="id"
                :options="positions"
                placeholder="Seleccione"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0">
            <div class="dropdown text-right">
              <button
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu pb-0 mt-1">
                <a class="drop-item cursor-pointer">
                  <em class="fas fa-edit text-green pr-1" />
                  <span>Editar</span>
                </a>
                <a class="drop-item cursor-pointer">
                  <em class="fas fa-times-circle text-red pr-1" />
                  <span>Eliminar</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="border-bottom d-flex align-items-center p-4">
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Fecha"
              rules="required"
            >
              <custom-input
                v-model="signature"
                type="text"
                placeholder="Escribir Nombre"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="tipo de dni"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedPosition"
                fieldname="name"
                fieldkey="id"
                :options="positions"
                placeholder="Seleccione"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0">
            <div class="dropdown text-right">
              <button
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu pb-0 mt-1">
                <a class="drop-item cursor-pointer">
                  <em class="fas fa-edit text-green pr-1" />
                  <span>Editar</span>
                </a>
                <a class="drop-item cursor-pointer">
                  <em class="fas fa-times-circle text-red pr-1" />
                  <span>Eliminar</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="border-bottom d-flex align-items-center p-4">
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Fecha"
              rules="required"
            >
              <custom-input
                v-model="signature"
                type="text"
                placeholder="Escribir Nombre"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="tipo de dni"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedPosition"
                fieldname="name"
                fieldkey="id"
                :options="positions"
                placeholder="Seleccione"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0">
            <div class="dropdown text-right">
              <button
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu pb-0 mt-1">
                <a class="drop-item cursor-pointer">
                  <em class="fas fa-edit text-green pr-1" />
                  <span>Editar</span>
                </a>
                <a class="drop-item cursor-pointer">
                  <em class="fas fa-times-circle text-red pr-1" />
                  <span>Eliminar</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-row-reverse bd-highlight w-100 my-4">
          <div class="mx-0 bd-highlight ml-2">
            <ActionButton
              data-target="#add-previous-evaluations-modal"
              data-toggle="modal"
              data-backdrop="static"
              variant="success"
              i="fas fa-file-plus"
            >
              A&ntilde;adir
            </ActionButton>
          </div>
        </div>
      </div>

      <div class="col-12 mt-4">
        <section-title content="PEI Inicial - Ubicación" :has-line="true" />
      </div>

      <div class="col-12 d-flex justify-content-between">
        <div class="col-4">
          <ValidationProvider v-slot="{ errors }" name="Fecha" rules="required">
            <custom-date-picker
              v-model="initPeiDate"
              label="Fecha Inicial del PEI: "
              format="dd/MMM./yyyy"
              required
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </ValidationProvider>
        </div>
        <div class="col-4">
          <ValidationProvider v-slot="{ errors }" name="Fecha" rules="required">
            <custom-date-picker
              v-model="initLocationDate"
              label="Ubicación Inicial: "
              format="dd/MMM./yyyy"
              required
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </ValidationProvider>
        </div>
        <div class="col-4">
          <ValidationProvider
            v-slot="{ errors }"
            name="tipo de dni"
            rules="required"
          >
            <custom-drop-down
              v-model="selectedLocation"
              fieldname="name"
              fieldkey="id"
              :options="locations"
              placeholder="Seleccione"
              label="Ubicación Inicial: "
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
      <div class="col-12 mt-4">
        <ValidationProvider
          v-slot="{ errors }"
          name="Comentario de elegibilidad"
          rules="required"
        >
          <custom-text-area
            v-model="initialPeiComment"
            :maxlength="500"
            placeholder="Escribir comentario"
            required
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/pei/shared/SectionTitle.vue';

import CustomDatePicker from '@/components/common/CustomDatePicker';
import CustomTextArea from '@/components/common/CustomTextArea';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { ActionButton } from '@/components/common';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomRadioButton from '@/components/common/CustomRadio';
import ControversyBanner from '@/components/pei/controversy/components/ControversyBanner';
import CustomChipsGroup from '@/components/common/CustomChipsGroup';
import CustomInput from '@/components/common/CustomInput';

export default {
  name: 'PostRegistrationTab',
  data() {
    return {
      initEvaluation: [
        {
          date: '17/Feb./2020',
          comment: 'El texto del comentario aparecerá aquí',
        },
      ],
      backupDocumentation: [],
      isCreatingBackupDocumentation: false,
      isEditingBackupDocumentation: false,
      eligible: false,
      attachedDocument: false,
      specialistNeeded: false,
      selectedDocumentType: null,
      rejectionReason: null,
      acceptedEvaluationInfo: null,
      determinesEvaluationInfo: null,
      eligibilityComment: null,
      rejectionComment: null,
      selectedImpedimentType: null,
      selectedImpedimentTypeItems: null,
      selectedPosition: null,
      selectedLocation: null,
      selectedMeetingsNumber: null,
      locations: null,
      initialPeiComment: null,
      initLocationDate: null,
      initPeiDate: null,
      signature: null,
      meetingsNumber: null,
      impedimentDate: null,

      positions: [
        { id: 0, name: 'Padre' },
        { id: 1, name: 'Trabajo' },
        { id: 2, name: 'Prima' },
      ],
      documentTypes: [
        {
          id: 0,
          type: 'Dni',
        },
      ],
      notAcceptedReasons: [
        {
          id: 0,
          name: 'Reason 1',
        },
        {
          id: 1,
          name: 'Reason 2',
        },
      ],
      impedimentSelectedItems: [
        {
          id: 0,
          title: 'AUT - Autismo ',
          subTitle: 'Trastorno: ',
          name: 'HI - Problema de Audición',
        },

        {
          id: 1,
          title: 'MR - Discapacidad Intelectual',
          subTitle: 'Severidad: ',
          name: 'VI - Impedimento Visual',
        },
      ],
      radioButtonsOptions: [
        { label: 'Si', value: 'true' },
        { label: 'No', value: 'false' },
      ],

      evaluationsInfo: [
        {
          id: 0,
          service: 'Adicional',
          discipline: 'Pediátrica',
          status: 'Previa',
          accepted: undefined,
          determines: undefined,
        },
        {
          id: 1,
          service: 'Adicional',
          discipline: 'Pediátrica',
          status: 'Previa',
          accepted: undefined,
          determines: undefined,
        },
        {
          id: 2,
          service: 'Adicional',
          discipline: 'Pediátrica',
          status: 'Previa',
          accepted: undefined,
          determines: undefined,
        },
      ],
      impedimentTypes: [
        {
          id: 0,
          name: 'Impedimentos Múltiples',
        },
        {
          id: 1,
          name: 'HI - Problema de Audición',
        },
        {
          id: 2,
          name: 'SLI - Problemas del Habla o Lenguaje',
        },
        {
          id: 3,
          name: 'VI - Impedimento Visual',
        },
        {
          id: 4,
          name: 'EMN - Disturbio Emocional',
        },
        {
          id: 5,
          name: 'OI - Impedimentos Ortopédicos',
        },
        {
          id: 6,
          name: 'OHI - Otros Impedimentos de Salud',
        },
        {
          id: 7,
          name: 'SLD - Problemas Específicos de Aprendizaje',
        },
        {
          id: 8,
          name: 'Daño cerebral por Trauma',
        },
        {
          id: 9,
          name: 'DD - Retraso en el desarrollo',
        },
      ],
    };
  },
  components: {
    SectionTitle,
    CustomDatePicker,
    CustomTextArea,
    ValidationProvider,
    ValidationObserver,
    ActionButton,
    CustomDropDown,
    CustomCollapse,
    CustomCollapseItem,
    CustomRadioButton,
    ControversyBanner,
    CustomChipsGroup,
    CustomInput,
  },
  methods: {
    async backupDocumentationItem() {},

    addDocument() {
      this.backupDocumentation.push({
        id: 0,
        documentName: 'Respaldo',
        fileName: 'determinacion_doc.pdf',
      });
      this.attachedDocument = true;
    },

    saveRejectionReasons() {
      this.rejectionReason = {
        id: 0,
        reason: this.selectedReason,
        comment: this.rejectionComment,
      };
    },
  },
};
</script>
<style scoped>
.header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}
.empty-table {
  background: #fafbfa 0% 0% no-repeat padding-box;
  opacity: 1;
}

.btn-border-green {
  width: 33px;
  height: 33px;
  border: 1px solid #2db782;
  border-radius: 4px;
  opacity: 1;
}

.btn-border-red {
  width: 33px;
  height: 33px;
  border: 1px solid #c9545e;
  border-radius: 4px;
  opacity: 1;
}

.dropdown-menu {
  margin-top: 1rem;
}
.dropdown-menu {
  margin-top: 1rem;
}
.dropleft .dropdown-toggle::before {
  display: none;
}
.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.green-box .input::after {
  content: '\f00c';
  color: #2db782;
  font-size: 20px;
}

.cuestion-text {
  text-align: left;
  font: Bold 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}

.impediment-divider {
  border: 0.5px solid #e1e1e1;
  opacity: 1;
}

.impediment-title {
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.certified-text {
  text-align: left;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}
.impediment-background {
  background: #fafbfa 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}
</style>
